import { Entity, PrimaryGeneratedColumn, Column, CreateDateColumn } from 'typeorm'

@Entity('measurement_data_shahi')
export class MeasurementDataShahiCarharttEntity {

    @PrimaryGeneratedColumn('increment', {
        name: 'id',
    })
    id: number

    @Column('varchar', {
        nullable: true,
        length: 300,
        name: 'measurement_data'
    })
    measurementData: string;

    @Column('varchar', {
        nullable: true,
        length: 300,
        name: 'style'
    })
    styleData: string;

    @Column('varchar', {
        nullable: true,
        length: 300,
        name: 'season'
    })
    seasonData: string;

    @Column('varchar', {
        nullable: true,
        length: 300,
        name: 'submit_date'
    })
    submitDate: string;

    @Column("boolean", {
        nullable: true,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


}